import { render, staticRenderFns } from "./VideoCallNotFound.vue?vue&type=template&id=a8218308&"
import script from "./VideoCallNotFound.vue?vue&type=script&lang=js&"
export * from "./VideoCallNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports